import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyShop = loadable(() => import(/* webpackChunkName: "content/publicshop" */ './Shop'));
